module.exports = __webpack_public_path__ + "img/2000_S.c8cd571d.png";